import {InfiniteData} from "@tanstack/query-core/src/types";
import {GetItemCounts} from "@twigsby/client-data";
import {ClientNamesResponseType} from "@twigsby/client-data/lib/Types/Response/ClientResponseTypes";
import {ComboBoxControl, SelectItemType} from "@twigsby/frontend-framework";
import {useEffect, useState} from "react";
import {useForwardingBatchProvider} from "../../../Providers/ForwardingBatchProvider";

type AccountNamesComboboxType = {
    name: string;
    callback: (item: SelectItemType) => void;
    defaultValue?: string;
    disabled?: boolean;
}

const AccountNamesCombobox = (props: AccountNamesComboboxType) => {
    const { accountNamesData, accountNamesStatus, accountNamesError } = useForwardingBatchProvider();
    const [ nameOptions, setNameOptions] = useState<Array<SelectItemType>>([]);

    const MapUserOptions = (data: InfiniteData<ClientNamesResponseType>) => {
        const filteredPostage = data?.pages.map((page) => page?.data && page.data.map((name, index: number) => {
            return { 'label': name.name, 'value': name.name }
        }));

        setNameOptions(filteredPostage.flat());
    };

    const HandleCallback = (item: SelectItemType) => {
        props.callback(item);
    }

    useEffect(() => {
        if(accountNamesData) {
            MapUserOptions(accountNamesData);
        }
    }, [accountNamesData]);

    return (
        <ComboBoxControl
            data={nameOptions}
            valueType={'string'}
            name={props.name}
            placeholder={''}
            singleSelection={true}
            forwardItemCallback={(item) => HandleCallback(item)}
            loading={accountNamesStatus === 'loading'}
            defaultValues={[props.defaultValue]}
            disabled={props.disabled}
        />
    )
}

export { AccountNamesCombobox }
